import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import { useTranslation } from '@mc/i18n'
import { CHECKOUT_I18N_NAMESPACE } from '../../../../i18n'
import { useNavigationSteps } from '../../useNavigationSteps'
import classes from './Step.module.scss'

interface StepProps {
  name: string
  stepId: number
  className?: string
}

export const Step = ({ name, stepId, className = '' }: StepProps) => {
  const {
    context: { currentStep },
  } = useNavigationSteps()
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const [isStepActive, setIsStepActive] = useState(false)

  useEffect(() => {
    setIsStepActive(currentStep >= stepId)
  }, [stepId, currentStep])

  return (
    <div className={cn(classes.step, className)}>
      <div
        className={cn({
          [classes.currentStepper]: isStepActive,
          [classes.stepper]: !isStepActive,
        })}
      />
      <div className='d-none d-md-block'>
        <p
          className={cn(
            'mc-text--center mc-mt-2',
            { 'mc-text-h8': isStepActive },
            { 'mc-text-x-small mc-opacity--muted': !isStepActive },
          )}
        >
          {name}&nbsp;
          <span className='mc-sr-only'>
            {currentStep === stepId && t('nav.steps.a11y.currentStep')}
            {currentStep > stepId && t('nav.steps.a11y.stepCompleted')}
          </span>
        </p>
      </div>

      <div className='d-block d-md-none'>
        <span className='mc-sr-only'>
          {name}&nbsp;
          {currentStep === stepId && t('nav.steps.a11y.currentStep')}
          {currentStep > stepId && t('nav.steps.a11y.stepCompleted')}
        </span>
      </div>
    </div>
  )
}
